import { enableProdMode, provideAppInitializer, inject, importProvidersFrom, ErrorHandler } from '@angular/core';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BearerTokenInterceptor } from './app/interceptors/bearer-token-interceptor';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { LocationStrategy, HashLocationStrategy, CurrencyPipe, DatePipe } from '@angular/common';
import { LocalStoreManager } from './app/services/local-store-manager/local-store-manager.service';
import { UtilitiesService } from './app/services/utilities/utilities.service';
import { OneCurrencyPipe } from './app/pipes/one-currency.pipe';
import { OneCurrencyEuroPipe } from './app/pipes/one-currency-euro.pipe';
import { ToastNotificationComponent } from './app/components/toast-notification/toast-notification.component';
import { StatePersistenceService } from './app/services/state-persistence/state-persistence.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './app/material.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SharedModule } from './app/modules/shared/shared.module';
import { AppComponent } from './app/app.component';
import { GlobalErrorHandler } from './app/error-handlers/global-error-handler/global-error-handler';

export function appInitializerFactory(statePersistenceService: StatePersistenceService): () => Promise<void> {
    return () =>
        statePersistenceService.loadState().then(() => {
            setTimeout(() => {
                document.getElementById('loader')?.remove();
            }, 10);
        });
}

const globalRippleConfig: RippleGlobalOptions = {
    disabled: true,
    animation: {
        enterDuration: 300,
        exitDuration: 0
    }
};

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, NgbModule, ReactiveFormsModule, FormsModule, AngularMaterialModule, TooltipModule.forRoot(), PopoverModule.forRoot(), SharedModule),
        { provide: HTTP_INTERCEPTORS, useClass: BearerTokenInterceptor, multi: true },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        LocalStoreManager,
        UtilitiesService,
        CurrencyPipe,
        OneCurrencyPipe,
        OneCurrencyEuroPipe,
        DatePipe,
        ToastNotificationComponent,
        provideHttpClient(withInterceptorsFromDi()),
        provideAppInitializer(() =>
            appInitializerFactory(inject(StatePersistenceService))()
        ),
        provideAnimations()
    ]
})
    .catch(err => console.error(err));
